//zh.js
module.exports={
  nav: {
		// 导航
	  index: '首页',
		/*********************/
	  aboutFortune: '关于富阳',
	  fortuneIntro: '富阳简介',
	  develop: '发展历程',
	  manageTeam: '管理团队',
//	  developVision: '发展愿景',
	  /*********************/
	  enterprise: '企业管治',
	  board: '董事会',
	  audit: '审核委员会',
	  payment: '薪酬委员会',
	  nominate: '提名委员会',
	  executiveCommittee: '执行委员会',
	  /*********************/
	  BusinessAreas: '业务领域',
	  GroupArchitecture: '房地产',
	  classicCase: '产业咨询',
	  international: '国际贸易',
		/*********************/
	  domesticCase: '国内个案',
	  ClassicCases: '产业咨询',
	  international: '国际贸易',
	  /*********************/
	  overseasCase: '海外置业',
	  BeltRoad: '一带一路',
	  Cambodia: '柬埔寨',
	  IntermediaryShop: '中介店',
	  /*********************/
	  investor: '投资者关系',
	  financeReporting: '财务报告',
	  GroupAnnouncement: '集团公告',
	  /*********************/
	  officeEntrance: '办公入口',
	  OAofficeSystem: 'OA办公系统',
	  enterpriseEmail: '企业邮箱登录',
	  salesSystem:'销售系统',
	  /*********************/
	  job:'招贤纳士',
	  relation: '联系我们',
	  /*********************/
	  languageSwitch: '语言',
	  zhLanguage: '简体',
	  tcLanguage: '繁体',
	  enLanguage: 'EN',
  },
	//首页
  index:{
  	aboutFortuneSun:'关于富阳',
	  aboutFSIntroduce1:'富阳（中国）控股成立于1997年，总部位于上海，2006年在香港联合交易所主板上市（编号00352），自成立以来，聚焦房地产、产业咨询、国际贸易三大核心业务，为政府、企业、机构投资者等提供国际化、专业化、整体化、全程化的高效服务。',
	  aboutFSIntroduce2:'秉持“专业成就未来”的理念，公司致力于成为具有国际视野、本土洞察的专业一站式综合解决方案服务商，以“聚合致远，注入价值”为使命，助力各方合作伙伴共创辉煌。',
  	clickEnter:'点击进入富阳',
      FSChina:'企业能力内核',
	  FSChinaIntroduce1:'● 28年品牌的迭代与沉淀  ',
	  FSChinaIntroduce2:'● 9年海外拓展与服务经验',
	  FSChinaIntroduce3:'● 两岸三地的业界精英团队',
	  FSChinaIntroduce4:'● 广泛的海外市场资源网络',
	  FSChinaIntroduce5:'● 国际品牌资源的协同整合',
	  FSChinaIntroduce6:'● 本地化的精准服务与经验'
  },
  // 关于富阳
  about:{
  	FSIntroduce:'自1997年创立以来，富阳（中国）控股公司凭借近30年来的行业专业性、敏锐的市场判断力和资本运营能力，践行产业化管理与专业化经营，业务领域涵盖房地产、产业咨询和国际贸易，为广大的中高端客户及高净值客户提供多元化及一站式的综合服务体系，致力于成为具有国际视野、本土洞察的专业一站式综合解决方案服务商。',
  	developmentImgIntroduce01:'热烈祝贺富阳（中国）控股于香港联交所主板上市',
  	developmentImgIntroduce02:'上海总部的同仁们庆祝集团在香港上市以HK0352创意合照',
  	developmentImgIntroduce03:'江陈锋主席在香港联交所与重要贵宾见证历史时刻并合影',
  	developmentImgIntroduce04:'首开先例的黄浦江邮轮豪华晚宴，达成企业和项目品牌的圆满联动',
  	developmentImgIntroduce05:'来自江浙沪港台的高端客户，为富阳（中国）控股成功打造优质品牌形象',
  	developmentImgIntroduce06:'张秀华执行董事为财富海景发展论坛致词',
  	developmentImgIntroduce07:'富阳（中国）控股同仁们送爱心到汶川灾区，慷慨解囊',
  	developmentImgIntroduce08:'张秀华执行董事带队走访肥东小学，让爱心满人间',
  	developmentImgIntroduce09:'2016年9月12日，富阳(中国)控股主席江陈锋先生与Creed Group总裁Takashi Eguchi先生签署合作协议，开启跨国战略共赢的首善之作',
  	developmentImgIntroduce10:'2016年11月19日，富阳（中国）控股主席江陈锋，日本creed集团董事长宗吉敏彦等各界领导与嘉宾共同为富阳海外置业展厅揭幕',
  	developmentImgIntroduce11:'2016年11月19日，海外盛世，缤纷启幕——富阳海外置业上海展厅耀世公开',
  	developmentImgIntroduce12:'2016年12月17日，富阳房地产公司及中介门店于柬埔寨首都金边正式开业',
  	developmentImgIntroduce13:'2017年12月14日，冬日地铁轻出行，富阳（中国）控股公益暖人心',
  	developmentVision:'严谨，诚信，专业是我们的服务理念，我们的服务涵盖房地产投资管理、房地产金融业务、房地产销售业务、房地产信息业务四大价值服务体系，以上海为运营总部，覆盖20多个省市，近100个城市，海外持续拓展亚洲、欧洲、美洲和东盟十国，以行业先锋之姿，提供开发商、客户们在风险和成本上的安全管理，并实现客户们在全球资产投资配置上的优化。'
  },
  // 管理团队
  manageTeam:{
  	director:'董事',
  	jiangchenfeng:'江陈锋先生，',
  	jcfIntroduce:'主席兼执行董事及本集团创办人之一。江先生于一九八九年六月毕业于台湾逢甲大学，取得企管系学士学位，并开始从事房地产评估及市场研究。于一九九五年至一九九六年间，江先生为沿海绿色家园有限公司（股份代号：01124）（其股份在香港联合交易所有限公司（「联交所」）主板上市）的研究员，专注于研究中国市场。江先生于一九九七年四月共同创办本集团，并自此获委任为上海富阳物业咨询有限公司（「上海富阳」）的董事。此外，亦为本公司其他附属公司的董事。',
	wangjia:'王佳女士，',
  	wjIntroduce:'目前为本公司全资附属公司上海富阳物业咨询有限公司（「上海富阳」）的董事，负责监督所有发展项目及管理本集团日常营运。王女士于一九九七年四月加入本集团，曾于上海富阳销售部门担任不同职位。王女士于一九九二年七月毕业于上海大学，主修机械设计制造。王女士拥有丰富的物业销售及营销经验，同时亦为上海房地产经纪人证书的持有人。',
	zhangxiuhua:'张秀华女士，',
  	zxhIntroduce:'执行董事。张女士于一九八八年六月毕业于台湾逢甲大学，取得财税系学士学位。于一九八八年，张女士加入仲庆汽车有限公司，负责估值及保险事宜。于一九九三年一月，张女士开始于衡平法律事务所工作，负责法务工作。张女士于一九九七年七月加入上海富阳，出任财务部经理，并于二零零零年一月获委任为上海富阳高级管理层成员之一，负责财务管理。于二零零五年八月，张女士获委任为上海富阳的董事。',
  	nonDirector:'非执行董事',
  	linqianru:'林倩如女士，',
  	lqrIntroduce:'非执行董事。林女士于一九九六年四月自美国酒店及汽车旅馆业协会教育学院(Educational Institute of the American Hotel and Motel Association)取得服务业管理文凭，并于一九九六年八月取得伦敦American University工商管理学士学位。林女士于一九九八年五月取得美国Dominican University of California管理学文学硕士学位。林女士为本集团的共同创办人之一。林女士自一九九七年四月起出任上海富阳董事一职。',
  	independentDirector:'独立非执行董事',
  	cuishiwei:'崔士威先生，',
  	cswIntroduce:'自二零零六年六月起出任独立非执行董事。崔先生于一九八六年七月获中国吉林大学法学院颁授法学硕士学位。于一九八六年七月至一九九二年七月期间，崔先生为吉林大学法学院讲师。崔先生曾在两家全国性保险公司及沿海绿色家园有限公司（股份代号：01124）（其股份在联交所上市）担任高级管理职务。',
  	zhengzhipeng:'邹耀明先生，',
  	zzpIntroduce:'持有香港大学会计及金融专业工商管理学士学位及伦敦大学专业会计学硕士学位。彼为特许公认会计师公会资深会员及香港会计师公会会员。彼在会计、核数、财务管理及企业融资方面拥有超过22年的经验。自1995年至2001年，彼为一家国际会计师事务所的核数师。自2001年起，彼曾在香港的上市及私人公司担任多个高级管理职位，包括财务总监和公司秘书。彼现为联交所主板上市的李氏大药厂控股有限公司（股份代号：00950）之财务总监及公司秘书。',
  	linjuncai:'林俊才先生，',
  	ljcIntroduce:'自二零一七年九月十九日起出任独立非执行董事。林先生于一九九零年获香港大学颁授社会科学学士学位，并于一九九七年取得香港律师资格。林先生曾于国际法律事务所及跨国上市公司提供法律顾问服务。彼于企业融资、公司及业务相关法律及法规之合规事宜拥有逾20年经验。',
  	seniorManagement:'高级管理层',
	  lvzhuohua:'吕焯华先生，',
  	lzhIntroduce:'自二零一七年五月起为本公司之财务总监，及后于二零一八年四月十四日起同时兼任公司秘书。吕先生具有逾10年的会计及金融行业经验。于加入本集团之前，吕先生曾于中瑞岳华（香港）会计师事务所有限公司担任助理审计经理。彼持有Curtin University of Technology会计专业商学学士学位，并为澳洲会计师公会及香港会计师公会的会员。',
	  wuyanhu:'武延虎先生，',
	  wyhIntroduce:' 总裁特别助理，协助本集团各项运营业务。武先生于二零零六年十一月加入本集团，曾担任上海富阳宁波分公司研展专员、研展经理，上海富阳柬埔寨公司副总经理，上海富阳研展经理及总裁助理。武先生于二零零六年七月毕业于东北师范大学经济学院金融专业。武先生具有十八年房地产研展及业务经验，并持有全国房地产经纪人证书。'
  },
	// 企业管治
  qiye:{
  	 boardDirectors:'董事会',
  	 boardDirectorsIntroduce:'本公司董事会现时由7名董事组成，包括3名执行董事江陈锋先生（主席）、韩林先生及张秀华女士，1名非执行董事林倩如女士，3名独立非执行董事邹耀明先生、林俊才先生及崔士威先生。董事会成员分担不同的角色及职能。董事会也设立了企业管治功能，并采纳书面企业管治功能职权范围。公司已设立董事会多元化政策。',
  	 auditCommittee:'审核委员会',
  	 auditCommitteeIntroduce:'审核委员会于二零零六年六月十日成立，并已采纳书面职权范围。<br>薪酬委员会由三名独立非执行董事邹耀明先生、林俊才先生及崔士威先生组成，而崔士威先生为薪酬委员会主席。',
  	 compensationCommittee:'薪酬委员会',
  	 compensationIntroduce:'薪酬委员会于二零零六年六月十日成立，并已采纳书面职权范围。<br>薪酬委员会由三名独立非执行董事邹耀明先生、林俊才先生及崔士威先生组成，而崔士威先生为薪酬委员会主席。',
  	 nominationsCommittee:'提名委员会',
  	 nominationsIntroduce:'提名委员会于二零零六年六月十日成立，并已采纳书面职权范围。<br>提名委员会由一名执行董事江陈锋先生及两名独立非执行董事邹耀明先生及林俊才先生组成，而江陈锋先生为提名委员会主席。',
  	 executiveCommittee:'执行委员会',
  	 executive:'执行委员会于二零零七年一月十二日成立，并已采纳书面职权范围。<br>执行委员会由三名执行董事江陈锋先生、韩林先生及张秀华女士组成，而江陈锋先生为执行委员会主席。'
  },
  // 集团架构
  jituan:{
  	totalTitle1:'中国元素，全球视野',
  	totalTitle2:'不断追求自我突破，持续创新',
  	JGTitleTouzi:'房地产投资管理',
  	JGContentTouzi:'富阳(中国)控股建立了服务全球华人的资产管理团队，凭借丰富的经验，掌握着前沿的本地市场知识和综合管理能力，帮助客户实现资产价值优化，为客户提供评估咨询，战略顾问，市场研究，项目开发与管理，项目租赁销售代理，物业与资产管理等服务。',
  	JGTitleJinrong:'房地产金融业务',
  	JGContentJinrong:'富阳(中国)控股以房产业务为核心，对大数据进行分析和挖掘，帮助优质投资标的与资本对接，实现资金的高效配置，保障客户房地产开发过程的顺利进行，促进房地产再生产过程中的资金良性循环。',
  	JGTitleXiaoshou:'房地产销售业务',
  	JGContentXiaoshou:'富阳(中国)控股拥有专业的房地产销售管理系统，利用先进的IT信息技术，结合自身22年的房地产专业经验，帮助客户在当前的行业经营形势下，对销售各个环节实时监控，实现业务流、信息流、资金流的整合管理。',
  	JGTitleXinxin:'房地产信息业务',
  	JGContentXinxin:'富阳(中国)控股以全渠道信息咨询服务系统，秉承“全面、及时、准确、适用、经济”的专业追求，为客户提供房地产开发信息、房地产市场供求信息、房地产交易信息等相关咨询服务。'
  },
	// 经典案例
/*	yewu:{
		invest:'房地产投资管理',
		caifuTitle:'上海财富海景花园',
		caifuIntroduce:'陆家嘴一线江景小豪宅',
		operatingManagement:'房地产金融业务',
		hongqiaoTitle:'上海虹桥国际科技广场',
		hongqiaoIntroduce:'虹桥国际级企业总部',
		crossoverMarketing:'房地产销售业务',
		hainanTitle:'海南雅居乐清水湾',
		hainanIntroduce:'占地2万亩，私属12公里海岸线，面向全国的度假圣品',
		putishu0:'房地产信息业务',
		putishu1:'金边菩提树',
		putishu2:'亚洲之星，东盟之钻'
	},
	//	国内个案
	GNgean:{
		Tc:'太仓 - 月星 . 星悦府',
		TcContent:'一府定城央，悦享新境界',
		langshi:'东台 - 朗诗 . 世纪绿郡',
		langshiContent:'匠心匠铸造健康人居',
		yuanrong:'南通 - 圆融 . 玺悦',
		yuanrongContent:'市北圆融心，东方奢雅宅',
		yongle:'上海 - 荣乐水岸',
		rongleContent:'松江老城心，最近繁华处',
		huaqing:'六安 - 华强 . 一号公馆',
		huaqingContent:'一生一城，共享美好',
		qiyun:'启东 - 启运上城',
		qiyunContent:'启运启天下，上城上人生',
		dafeng:'大丰 - 天居珑悦府',
		dafengContent:'天成雅境，府悦春秋',
		NTTitle:'南通-顺发御园',
		NTContent:'大玩家、朋友圈、趣院子<br>军山下300亩纯墅区',
		XJZYTitle:'盐城 - 西郊庄园',
		XJZYContent:'墅以西为贵241-402m2<br>法式庄园别墅，一城仰望',
		BLGGTitle:'南通 - 巴黎公馆',
		BLGGContent:'全城第1景<br>天安板块，市中心生活地标',
		WLJHTitle:'宜昌 - 伍领江湖',
		WLJHContent:'预见繁华 · 预约芳华<br>67-155m2龙盘湖江景高层',
		YJTDTitle:'宜昌 - 御景天地',
		YJTDContent:'九景之境，<br>五感山居三万方生态园林，<br>典雅慢生活',
		LYCTitle:'大丰 - 望园 · 来茵城',
		LYCContent:'最高100米超宽栋距，<br>闹中取静实景现房，<br>生活之道',
		YLSATitle:'上海 - 荣乐水岸',
		YLSAContent:'松江老城心，最近繁华处<br>三期新品，王者归来',
		NTBYTitle:'南通 - 南通别业',
		NTBYContent:'一府封疆 · 墅藏东方',
		QCWCTitle:'嘉兴 - 清池温泉度假村',
		QCWCContent:'沪杭示范区，小镇经济圈<br>私人定制金奖温泉度假村',
		JHCTitle:'南通 - 景华城',
		JHCContent:'商圈、学区、地铁、现房<br>身处好风景，举步皆繁华',
		XSGTitle:'宁波 - 象山港文化广场',
		XSGContent:'品牌抢进·文化产金<br>抢铺·落户·金学区'
	},
	//海外置业
//	hyzy:{
		hyzyText1:'富阳海外置业用全球战略眼光来寻觅优质海外资产，以具实效的市场资讯和专业的投资分析，助您做出更英明的投资决策。',
		hyzyText2:'近年来富阳海外置业深耕欧美、东南亚高端房地产业务，与诸多知名海外房产企业建立合作关系。富阳海外置业以专业的海外专家团队，从资产筛选、税务咨询、银行贷款到交易流程，为您提供全程置业咨询。',
		hyzyText3:'伴随着经济的迅速发展，中国私人财富和高净值人群正保持着快速增长，人们更加重视财富保障和传承，资产配置趋向多元化，海外置业的需求愈发强烈。'
	},
  // 一带一路
//  road:{
  	sichou1:'2013年9月和10月，中国政府先后提出共建“丝绸之路经济带”和“21世纪海上丝绸之路”（以下简称“一带一路”，英文简称The Belt and Road）的倡议，得到国际社会的高度关注和有关国际的积极响应。2015年3月28日，国家发展改革委、外交部、商务部联合发布了《推动共建丝绸之路经济带和21世纪海上丝绸之路的愿景与行动》，倡导共建“一带一路”致力于亚欧非大陆及附近海洋的互联互通，建立和加强沿线各国互联互通伙伴关系，构建全方位、多层次、复合型的互联互通网络，实现沿线各国多元、自主、平衡、可持续的发展。',
  	sichou2:'在“一带一路”的倡议引领下，每年亚太地区基础设施建设的资金需求大概有7000亿美元，“一带一路”建设积极效应逐步显现，基础建设的逐渐完善也让东南亚的房产市场成为海外投资新宠。以“一带一路”沿线的泰国、柬埔寨、马来西亚三国的海外房产投资数据为基础，结合三个国家的国别宏观概况和当地房产市场分析，意在帮助国人了解相关国家的经济发展现状和海外房产投资形势。',
  	map1:'数据显示泰国曼谷房地产均价折合人民币约为25700元/㎡，年均涨幅高达12.3%；泰国、柬埔寨、马来西亚三国的热门城市均价均已超过一万，',
  	map2:'金边房地产均价超过人民币两万元每平米。值得注意的是：三国租金收益率一般在5%-8%，相比北京上海1%的租金收益率要高很多。',
  	roadTitle1:'“一带一路”三国国情概览',
  	gdpContent:'“一带一路”三国的GDP，人口总数均呈现增长趋势。',
  	roadTitle2:'一带一路中的东南亚 - 新财富 新通路',
  	caifuContent1:'“一带一路”倡议提出的三年多来，国内和国际两方面都取得丰硕成果和积极的影响，大力推动东南亚的协同发展。目前我国已跟四十多个国家和国际组织签署了五十多份共建协议，促进了国家间的合作，带动了泰国，马来西亚，柬埔寨等国家的GDP，人口总数，房地产市场价格的大幅增长。以绿城，碧桂园为首的知名房地产企业更是纷纷转向东南亚市场。',
  	caifuContent2:'目前主流国家均已对中国人开放房地产购买权，吸引了中国海外投资大军的目光，数据显示中国人最新换购置房产的城市为曼谷，目前曼谷房地产均价约25700元，芭提雅、普吉岛等城市也比较受欢迎。100万在北京、上海等地已经很难买到房子的情况下，在“一带一路”三国中还有更多财富的选择。',
  	thL1:'数据',
  	thL2:'马来西亚',
  	thL3:'泰国',
  	thL4:'柬埔寨',
  	tbL11:'GDP',
  	tbL12:'296亿美元',
  	tbL13:'395亿美元',
  	tbL14:'180亿美元',
  	tbL21:'GDP增长率',
  	tbL22:'4.95%',
  	tbL23:'2.81%',
  	tbL24:'7.03%',
  	tbL31:'人均GDP约',
  	tbL32:'9766美元',
  	tbL33:'5816美元',
  	tbL34:'1159美元',
  	tbL41:'互联网普及率',
  	tbL42:'67.5%',
  	tbL43:'34.89%',
  	tbL44:'9%',
  	tbL51:'人口总数',
  	tbL52:'3033万',
  	tbL53:'6796万',
  	tbL54:'1558万',
  	tbL61:'人口增长率',
  	tbL62:'1.42%',
  	tbL63:'0.34%',
  	tbL64:'1.6%',
  	tbL71:'城市人占比',
  	tbL72:'74.71%',
  	tbL73:'50.37%',
  	tbL74:'20.72%',
  	tbL81:'进出口总额约',
  	tbL82:'10200563万美元',
  	tbL83:'7262116万美元',
  	tbL84:'375765万美元',
  	tbL91:'实际利用外商直接投资额约',
  	tbL92:'15749万美元',
  	tbL93:'6052万美元',
  	tbL94:'312万美元'
  },
	// 柬埔寨
//	jpz:{
		projectIntroduce:'项目介绍',
		projectContent:'2017,跟着国家“一带一路”赚大钱低门槛投资20年前的上海！柬埔寨首都金边，政局稳定！GDP8%高速增长，年房价达30％涨幅！政府多项利好政策，吸引外资成倍增长！旅游业发达租赁需求大，已成最佳海外房产投资国家！全面美金流通，货币强势无外汇管制！房产租金高达10%回报，比股票、基金更迷人！永久产权，东盟十国首都房价洼地，更具吸引力！一带一路，泛亚铁路2020年通车！毗邻百盛商场，卡塔尔航空五星级酒店，大型免税商场！45％绿化，户户送车位，栋栋屋顶泳池！项目地段：柬埔寨首都金边俄罗斯大道，毗邻百盛商场！10分钟直达金边行政商务区和金边旅游开发区。',
		plwsIntroduce:'项目介绍',
		plwsContent1:'普罗旺斯公寓座落BKK1使馆区，拥有得天独厚的地理位置，区域内高级公寓林立，临近大皇宫、Naga金界娱乐城、日本Aeon Mall全天候享不停精彩都市生活！',
		plwsContent2:'拥有普罗旺斯的6大理由：①一层５户，私密单纯。②烫金地段，坐享增值。③使馆特区，稀缺小豪宅。④轻总价，坐擁美金資產。 ⑤配套齐全，拎包入住。⑥百强优质房客即将入住，租金無憂。',
		countryIntroduce:'国家介绍：寻找美金资产中的价值洼地',
		countryContent1:'柬埔寨位于亚洲东南部的中南半岛南部。大多数人对柬埔寨的印象，来自于世界七大奇景之一的吴哥窟，以及充满着强烈对比的人文风情和柬埔寨特有的风土景致，为游客留下了视觉与心理上的巨大震撼，使得柬埔寨深受世界各地的旅客喜爱。',
		countryContent2:'近年来，柬埔寨经济高速稳定的发展，吸引了大量的国际资本进驻投资。每一次到达首都金边都会让人感受到城市风貌不断在蜕变，天际线四处看到是高耸的建筑起重机，彷佛置身在当年的上海浦东新区一般，这就是柬埔寨市场火热的象征。',
		clickBtnText:'点击进入'
	},
	// 菩提树项目介绍
//	jpzProject:{
		jpzPTitle1:'城市中央  尽享繁华',
		jpzPContent1:'往往1%的区域，承担起了一座城市99%的盛名<br>菩提树公寓，雄踞金边城市核心区，位于俄罗斯大道<br>毗邻百盛商场，与金边国际机场隔街相望<br>距离金边皇家医院仅10分钟车程<br>15分钟即达金边高尔夫俱乐部，即刻融入精彩国际都市生活<br>',
		jpzPContentMO1:'往往1%的区域，承担起了一座城市99%的盛名，菩提树公寓，雄踞金边城市核心区，位于俄罗斯大道，毗邻百盛商场，与金边国际机场隔街相望，距离金边皇家医院仅10分钟车程，15分钟即达金边高尔夫俱乐部，即刻融入精彩国际都市生活。',
		jpzPTitle2:'目之所及  皆是公园',
		jpzPContent2:'身处公园中，拥抱大自然<br>菩提树公寓采用园林式景观设计，45%的超高绿化率<br>超大的天台花园<br>用匠心将宁静悠绿的花园做到极致<br>精雕细琢只为给您一个优雅环境<br>在繁华城央，实现一座城市的公园理想',
		jpzPContentMO2:'身处公园中，拥抱大自然，菩提树公寓采用园林式景观设计，45%的超高绿化率，超大的天台花园，用匠心将宁静悠绿的花园做到极致，精雕细琢只为给您一个优雅环境，在繁华城央，实现一座城市的公园理想。',
		jpzPTitle3:'生得灵动  活得美丽',
		jpzPContent3:'从人性化的设计开始，菩提树公寓始终印证业主的尊贵身份<br>公寓内的中央花园采用现代化人居设计<br>为业主的社交会友提供了一个完美空间，天台花园，无边泳池<br>露天咖啡馆，儿童游乐场等每一处的精心规划<br>都是为了给您一个平静而舒适的五星生活<br>',
		jpzPContentMO3:'从人性化的设计开始，菩提树公寓始终印证业主的尊贵身份，公寓内的中央花园采用现代化人居设计，为业主的社交会友提供了一个完美空间，天台花园，无边泳池，露天咖啡馆，儿童游乐场等每一处的精心规划，都是为了给您一个平静而舒适的五星生活。'
	},
	// 普罗旺斯项目介绍
//	plwsProject:{
		plwsPTitle1:'BKK1使馆区，南法风情高层建筑',
		plwsPContent1:'本案位于柬埔寨核心区域BKK1中302路，这里是侨民、企业和高净值居民的聚集地，地段尊贵稀缺，采南法风情高层建筑，视野极佳，环境单纯，闹中取静，出行顺畅，深受海内外高端人士喜爱收藏。',
		plwsPTitle2:'拎包入住，星级配套，置业无忧',
		plwsPContent2:'普罗旺斯公寓拥有完备多功能的生活设施，精心规划无边泳池、空中花园和健身房等公共休闲区域，同时，星级物业的贴心管理服务，家具配套齐全，投资，自住，出租，高枕无忧，让住户们即买即享受，尽情挥洒国际大都会生活。'
	},
	// 柬埔寨国家介绍
//	jpzState:{
		USDTitle:'寻找美金资产中的价值洼地',
		USDContent1:'柬埔寨位于亚洲东南部的中南半岛南部。大多数人对柬埔寨的印象，来自于世界七大奇景之一的吴哥窟，以及充满着强烈对比的人文风情和柬埔寨特有的风土景致，为游客留下了视觉与心理上的巨大震撼，使得柬埔寨深受世界各地的旅客喜爱。',
		USDContent2:'近年来，柬埔寨经济高速稳定的发展，吸引了大量的国际资本进驻投资。每一次到达首都金边都会让人感受到城市风貌不断在蜕变，天际线四处看到是高耸的建筑起重机，彷佛置身在当年的上海浦东新区一般，这就是柬埔寨市场火热的象征。',
		newStandard:'柬埔寨 — 海外房产置业新标的',
		newStandardC1:'1.从当前通胀水平看，人民币未来存在不小的贬值压力，汇率下跌趋势已基本确定',
		newStandardC2:'2.美元汇率近几年持续走高，已成为最保值的货币之一，投资美元资产可以起到保值的作用',
		jpzChooseTitle:'选择柬埔寨置业的5大理由',
		jpzChooseC1:'1.市场经济腾飞，GDP连续6年增长超过7%，是全球近十年来成长最快速的国家之一',
		jpzChooseC2:'2.地处东盟中心，更是“一带一路”的枢纽，大量基础设施建设投资，带动楼市增长',
		jpzChooseC3:'3. 超高人口红利，亚洲平均年龄最低的国家，拥有众多年轻劳动力，人口红利未来带动经济强力增长',
		jpzChooseC4:'4. 超高投资价值，金边租金收益率可达10%，居东南亚城市之首，外国人持护照即可购买，并拥有永久产权',
		jpzChooseC5:'5. 美元资产抗贬值，投资柬埔寨资产即是投资美元资产，美元汇率近年来持续走高，强势货币，财富保值更增值',
		jpzCityTitle:'柬埔寨三大城市 — 历史与现代的完美交融',
		jpzCity1:'金边市',
		jpzCityContent1:'金边是柬埔寨首都，地处柬埔寨中部平原，处于湄公河、洞里萨河和巴萨河的交汇处，面积289平方公里，人口约130万。自1434年起成为柬首都，是全国政治、经济、文化中心，也是国内、国际航空和水陆交通枢纽。',
		jpzCity2:'西哈努克市',
		jpzCityContent2:'西哈努克市旧称磅逊市，位于柬南部，西临泰国湾，距金边约240公里，拥有柬唯一的国际海港。该市气候湿润，海滩闻名，是柬著名的度假胜地。整座岛上没有一条公路，是一个不受尘世沾染的世外桃源。',
		jpzCity3:'暹粒省',
		jpzCityContent3:'暹粒省文物古迹繁多，旅游资源丰富，共有古寺庙292个，被联合国教科文组织列为世界七大奇迹之一的著名吴哥古迹就坐落在暹粒市以北6公里处，中南半岛最大的淡水湖——洞里萨湖位于该省南端。',
	},
	// 中介店
//	zjd:{
		zjdIntroduce:'富阳（中国）控股深耕中国市场，以“中国元素，全球视野”提供客户多元化，优质化的房地产专业信息及管理服务内容，并在金边设立富阳房地产公司及中介门店，让广大的海内外客户享有便捷，专业，全方位的高效服务。',
		zjdTitle:'富阳房地产中介店主营',
		zjdIcon1:'资产管理',
		zjdIcon2:'土地',
		zjdIcon3:'厂房',
		zjdIcon4:'写字楼',
		zjdIcon5:'二手房',
		zjdIcon6:'租房',
		zjdIcon7:'新房',
		zjdCompany:'富阳房地产公司及中介门店',
		zjdCompanyContent:'为高端客户提供更多元化的房产政策税务咨询，投资购置，代租，代售，代管一站式的房地产管理服务。',
		guanjiaTitle:'专属私人管家',
		guanjiaContent:'提供一对一客户专属私人管家服务，让业主不必对跨国物业管理担心，所有关于房屋的租赁、买卖、日常管理、家私维修，业主可以直接点对点的咨询自己的私人管家。',
		zulinTitle:'租赁与买卖',
		zulinContent1:'• 免费提供挂牌信息',
		zulinContent2:'• 提供二手房买卖服务，按成交总价的1%收取中介费',
		zulinContent3:'• 提供房屋长租、短租服务：1年以上租约收取1个月的租金为中介费',
		daishoukuanTitle:'代收款',
		daishoukuanContent1:'• 定期催收租金，并转账至业主账户',
		daishoukuanContent2:'（汇款手续费由业主承担）',
		daishoukuanContent3:'• 代缴相关费用',
		daishoukuanContent4:'（年度房屋税、物业管理费、公共水电费等）',
		qingjieTitle:'居家清洁服务',
		qingjieContent1:'• 根据业主要求可随时提供单次物业清洁',
		qingjieContent2:'（提供清洁费用明细）',
		qingjieContent3:'• 每次租期结束后，免费提供一次物业整套清洁服务',
		qingjieContent4:'• 洗衣服务(根据实际洗衣重量、种类计价)',
		xiushanTitle:'居家修缮',
		xiushanContent1:'• 物业主体修缮：例如上下水管道、房屋墙面等主体结构在保修范围以外的维修（根据维修清单实报实销）',
		xiushanContent2:'• 物业室内家具、家电维修（根据维修清单实报实销）',
		qitaTitle:'其他附加服务',
		qitaContent1:'• 定期巡视空屋并视频空屋现状',
		qitaContent2:'• 代订酒店、租车',
		qitaContent3:'• 通过我们的管理公司于当地同类型房屋租赁，业主可享有一定折扣优惠入住',
		qitaContent4:'• 免费咨询当地房地产相关法律法规',
		qitaContent5:'• 当地的房地产市场行情，包含售价、租金'
	},
//	vhouse:{
		vhouseTitle1:'小宅大作 开启你的V生活<br>ផ្ទះប្រណីខ្នាតតូច  ចាប់ផ្តើមជីវិត V របស់អ្នក',
		vhouseContent1:'上风 上景 上层家 <br>立足城市居所让生活更出彩<br>俯瞰拥抱绿意美景，出门连线国际商圈<br>景致意境 尽收眼底<br>兼得繁华与宁静，成就都市新生活<br>拥有V-HOUSE高层景观美宅<br>从此生活由你来定义 <br><br>ទីតាំងល្អ  ទេសភាពល្អ  ផ្ទះល្អ  <br>ធ្វើឱ្យការរស់នៅរបស់អ្នកនៅទីក្រុងកាន់តែស្រស់បំព្រង  <br>មានទេសភាពបៃតង   នៅជុំវិញតំបន់ពាណិជ្ជកម្មអន្តរជាតិ  <br>សោភ័ណ្ឌភាពបែបលក្ខណៈសិល្បៈ  ទេសភាពធំទូលាយ  <br>មានទាំងវិបុលភាព និងភាពស្ងប់ស្ងាត់  នេះជាជីវិតថ្មីនៅក្នុងទីក្រុង។  <br>ជាមួយនឹងផ្ទះ V-HOUSE ជាន់ខ្ពស់មានទេសភាពដ៏ស្រស់ស្អាត  <br>ជីវិតរបស់អ្នកនឹងមានភាពស្រស់ស្រាយ។',
		vhouseTitle2:'大视野 高层上 风景这边独好 <br> ទេសភាពធំល្វឹងល្វើយ ខ្ពស់ស្រឡះ សោភ័ណ្ឌភាពពិសេស',
		vhouseContent2:'现代人们的生活在高速发展的社会中一丝不苟的运转着，是时候寻觅一处舒适场所让在都市中忙碌的身心全方位放松。多朝向醉美景观，视野全面无遮挡，俯瞰绿意美景，都市繁华尽收眼底。暖阳洒进，让所有的烦恼与疲惫无影无踪。华灯初上，万家的灯火让心绪无比温馨。住进城心“V-House”，成就人生新高度。一眼望去，蔚然无限。鸟语花香从容交错，和谐安详的景致平添温暖。周边配套齐全，临近国际商圈。不仅繁华垂手可得，更拥有难得的宁静氛围。<br><br>ជីវភាពរស់នៅរបស់មនុស្សសម័យថ្មីកំពុងតែមានការវិវត្តនៅក្នុងសង្គមដែលមានការរីកចម្រើនយ៉ាងឆាប់រហ័ស។ ដល់ពេលហើយដែលត្រូវស្វែងរកកន្លែងសោយសុខដើម្បីបន្ធូរអារម្មណ៍ទាំងផ្លូវកាយនិងផ្លូវចិត្តនៅក្នុងការរស់នៅក្នុងទីក្រុងដ៏មមាញឹក។ ផ្តោតជាសំខាន់លើទេសភាពដ៏ស្រស់ស្អាត អាចមើលធំល្វឹងល្វើយ និងមើលទេសភាពបៃតង និងអាចមើលទិដ្ឋភាពទីក្រុងមានសភាពអ៊ូអរ។ ពន្លឺព្រះអាទិត្យដ៏កក់ក្តៅធ្វើឱ្យអ្នកបាត់កង្វល់ និងភាពនឿយណាយ។ នៅពេលភ្លើងពេលរាត្រីបានបំភ្លឺឡើង ពន្លឺភ្លើងចេញពីផ្ទះរាប់ពាន់ផ្ទះធ្វើឱ្យអារម្មណ៍របស់អ្នកកក់ក្តៅ។ ស្ថិតនៅចំណកណ្តាលនៃទីក្រុង  "V-House" បង្កើតលំដាប់ថ្នាក់ខ្ពស់ថ្មីនៃការរស់នៅ។ គ្រាន់តែក្រឡេកមើលភ្លាម វិសាភាពធំល្វឹងល្វើយគ្មានព្រំដែន។ សំឡេងបក្សាបក្សី និងក្លិនផ្កាលាយចំរុះគ្នា ហើយទេសភាពសុខដុមរមនានិងសន្តិភាពបង្កើនអារម្មណ៍កក់ក្ដៅ។ តំបន់ជុំវិញមានបំពាក់គ្រឿងសង្ហារិមគ្រប់គ្រាន់ ហើយនៅជិតតំបន់ពាណិជ្ជកម្មអន្តរជាតិ។ មិនតែមានភាពរីកចម្រើន ថែមទាំងប៉ុន្តែមានបរិយាកាសស្ងប់ស្ងាត់ចង់រស់នៅ។',
		vhouseTitle3:'大荣耀   当房子变成家 一切悠然自得 <br>ជោគជ័យដ៏អស្ចារ្យ នៅពេលដែលផ្ទះក្លាយទៅជាកម្មសិទ្ធិរបស់អ្នក ធ្វើឱ្យអ្នកមានអារម្មណ៍ស្រណុកសុខស្រួល។',
		vhouseContent3:'习惯了快节奏的生活，喜欢与时间赛跑。但在这里，一切皆可慢慢享受。V-House公寓紧邻TK商圈与永旺2期。每一户都采用科学户型设计，整体动线流畅合理，每户配备观景大阳台为住户提供欣赏全城美景的私密空间。把美景独享亦或分享，皆为美事。挑一个温暖的下午，蜷在慵懒的沙发上看一部期待已久的电影，或和三两好友，品茗小酌各自的精彩。在这里，与自己的理想不期而遇。<br><br>អ្នកមានទម្លាប់រស់នៅក្នុងជីវិតដ៏មមាញឹកឆាប់រហ័ស និងចូលចិត្តប្រណាំងប្រជែងជាមួយពេលវេលា។ ប៉ុន្តែនៅទីនេះអ្នកអាចសោយសុខគ្រប់យ៉ាងដោយសន្សឹមៗ។ ខុនដូ V-House មានទីតាំងស្ថិតនៅជាប់តំបន់ពាណិជ្ជកម្មទួលគោក និងផ្សារទំនើបអ៊ីអ៉នពីរ។ផ្ទះនីមួយៗប្រើប្រាស់ការរចនាប្លង់លក្ខណៈវិទ្យាសាស្រ្តជាមួយនឹងចលនាទាំងមូលដែលលក្ខណៈរលូន និងសមស្រប។ ផ្ទះនីមួយៗមានរានហាលធំទូលាយដែលផ្តល់អ្នកនូវកន្លែងឯកជនដើម្បីរីករាយគយគន់ភាពស្រស់ស្អាតនៃទីក្រុង។ វាជារឿងល្អក្នុងការរីករាយ ឬចែករំលែក។ ឆ្លៀតពេលរសៀល អង្គុយលើសាឡុងមើលភាពយន្ត ឬជជែកកម្សាន្តសប្បាយជាមួយមិត្តភ័ក្តិរបស់អ្នកនិងរីករាយទទួលទានទឹកតែល្អ។',
		vhouseTitle4:'大价值 一屋在手 精彩生活轻松拥有 <br>គុណតម្លៃដ៏អស្ចារ្យ  ជីវិតដ៏អស្ចារ្យនិងងាយស្រួលក្នុងផ្ទះរបស់អ្នកផ្ទាល់',
		vhouseContent4:'25岁买房，30岁而立，偌大的城市，青春有限，自由无价，现在你也能轻松当房东！省下几件名牌华服，让年纪轻轻的当下就提早拥有一间优质的家！V-House精品公寓秉承现代人居理念，小户型，轻总价，买得起，住得好。所在区域潜力巨大，自住或投资出租，即买即享受。依靠，一个叫家的地方。我们的自由天地，完全属于自己！空间独立，休闲放松，更多开心，满足与安全感。在属于自己的一方天地里，生活可以无限精彩！独立自主，轻松置业，是时候了。<br><br>ទិញផ្ទះនៅអាយុ 25 ឆ្នាំ ហើយកសាងស្នាដៃនៅអាយុ 30។ ជាមួយនឹងទីក្រុងធំ យុវ័យរបស់អ្នកមានដែនកំណត់ មានសេរីភាពហើយមិនអាចកាត់ថ្លៃ ឥឡូវនេះអ្នកអាចក្លាយជាម្ចាស់ផ្ទះបានយ៉ាងងាយស្រួល! សន្សំថវិការបស់អ្នកដើម្បីទិញផ្ទះល្អមួយខ្នងនៅពេលអ្នកនៅក្មេង! ខុនដូ V-House បង្កប់នូវគោលគំនិតថ្មីនៃការរស់នៅ  មានទំហំតូច តម្លៃសមរម្យនិងងាយស្រួលក្នុងការរស់នៅប្រកបដោយផាសុកភាព។ តំបន់នេះមានសក្តានុពលច្រើន ដូច្នេះអ្នកអាចរស់នៅ ឬវិនិយោគដោយដាក់ជួល។ ទិញដើម្បីសោយសុខ។ កន្លែងនេះហៅថាផ្ទះគ្រួសារ។ ពិភពរបស់យើងគឺសេរីភាពរបស់យើង! អ្នកអាចធ្វើជាម្ចាស់ផ្ទះដើម្បីភាពឯកជន ការសម្រាកលំហែ សុភមង្គលសេចក្តីពេញចិត្តនិងសុវត្ថិភាពរបស់អ្នក។ នៅក្នុងពិភពរបស់អ្នក ជីវិតរបស់អ្នកអាចមានភាពអស្ចារ្យ! ដល់ពេលហើយដែលត្រូវមានភាពឯករាជ្យម្ចាស់ការ ដោយទិញអចលនទ្រព្យដ៏អស្ចារ្យនេះ។',
		soonOpen:'即将引爆公开 <br>បែបផែន៖ជិតមកដល់ក្នុងពេលឆាប់ៗនេះហើយ',
		
		vhPCT1:'小宅大作 开启你的V生活',
		vhPCC1:'上风 上景 上层家 <br>立足城市居所让生活更出彩<br>俯瞰拥抱绿意美景，出门连线国际商圈<br>景致意境 尽收眼底<br>兼得繁华与宁静，成就都市新生活<br>拥有V-HOUSE高层景观美宅<br>从此生活由你来定义',
		vhPCTJ1:'ផ្ទះប្រណីខ្នាតតូច  ចាប់ផ្តើមជីវិត V របស់អ្នក',
		vhPCCJ1:'ទីតាំងល្អ  ទេសភាពល្អ  ផ្ទះល្អ  <br>ធ្វើឱ្យការរស់នៅរបស់អ្នកនៅទីក្រុងកាន់តែស្រស់បំព្រង  <br>មានទេសភាពបៃតង   នៅជុំវិញតំបន់ពាណិជ្ជកម្មអន្តរជាតិ  <br>សោភ័ណ្ឌភាពបែបលក្ខណៈសិល្បៈ  ទេសភាពធំទូលាយ  <br>មានទាំងវិបុលភាព និងភាពស្ងប់ស្ងាត់  នេះជាជីវិតថ្មីនៅក្នុងទីក្រុង។  <br>ជាមួយនឹងផ្ទះ V-HOUSE ជាន់ខ្ពស់មានទេសភាពដ៏ស្រស់ស្អាត  <br>ជីវិតរបស់អ្នកនឹងមានភាពស្រស់ស្រាយ។',
		
		vhPCT2:'大视野 高层上 风景这边独好',
		vhPCC2:'现代人们的生活在高速发展的社会中一丝不苟的运转着，是时候寻觅一处舒适场所让在都市中忙碌的身心全方位放松。多朝向醉美景观，视野全面无遮挡，俯瞰绿意美景，都市繁华尽收眼底。暖阳洒进，让所有的烦恼与疲惫无影无踪。华灯初上，万家的灯火让心绪无比温馨。住进城心“V-House”，成就人生新高度。一眼望去，蔚然无限。鸟语花香从容交错，和谐安详的景致平添温暖。周边配套齐全，临近国际商圈。不仅繁华垂手可得，更拥有难得的宁静氛围。',
		vhPCTJ2:'ទេសភាពធំល្វឹងល្វើយ ខ្ពស់ស្រឡះ សោភ័ណ្ឌភាពពិសេស',
		vhPCCJ2:'ជីវភាពរស់នៅរបស់មនុស្សសម័យថ្មីកំពុងតែមានការវិវត្តនៅក្នុងសង្គមដែលមានការរីកចម្រើនយ៉ាងឆាប់រហ័ស។ ដល់ពេលហើយដែលត្រូវស្វែងរកកន្លែងសោយសុខដើម្បីបន្ធូរអារម្មណ៍ទាំងផ្លូវកាយនិងផ្លូវចិត្តនៅក្នុងការរស់នៅក្នុងទីក្រុងដ៏មមាញឹក។ ផ្តោតជាសំខាន់លើទេសភាពដ៏ស្រស់ស្អាត អាចមើលធំល្វឹងល្វើយ និងមើលទេសភាពបៃតង និងអាចមើលទិដ្ឋភាពទីក្រុងមានសភាពអ៊ូអរ។ ពន្លឺព្រះអាទិត្យដ៏កក់ក្តៅធ្វើឱ្យអ្នកបាត់កង្វល់ និងភាពនឿយណាយ។ នៅពេលភ្លើងពេលរាត្រីបានបំភ្លឺឡើង ពន្លឺភ្លើងចេញពីផ្ទះរាប់ពាន់ផ្ទះធ្វើឱ្យអារម្មណ៍របស់អ្នកកក់ក្តៅ។ ស្ថិតនៅចំណកណ្តាលនៃទីក្រុង  "V-House" បង្កើតលំដាប់ថ្នាក់ខ្ពស់ថ្មីនៃការរស់នៅ។ គ្រាន់តែក្រឡេកមើលភ្លាម វិសាភាពធំល្វឹងល្វើយគ្មានព្រំដែន។ សំឡេងបក្សាបក្សី និងក្លិនផ្កាលាយចំរុះគ្នា ហើយទេសភាពសុខដុមរមនានិងសន្តិភាពបង្កើនអារម្មណ៍កក់ក្ដៅ។ តំបន់ជុំវិញមានបំពាក់គ្រឿងសង្ហារិមគ្រប់គ្រាន់ ហើយនៅជិតតំបន់ពាណិជ្ជកម្មអន្តរជាតិ។ មិនតែមានភាពរីកចម្រើន ថែមទាំងប៉ុន្តែមានបរិយាកាសស្ងប់ស្ងាត់ចង់រស់នៅ។',
		
		vhPCT3:'大荣耀   当房子变成家 一切悠然自得',
		vhPCC3:'习惯了快节奏的生活，喜欢与时间赛跑。但在这里，一切皆可慢慢享受。V-House公寓紧邻TK商圈与永旺2期。每一户都采用科学户型设计，整体动线流畅合理，每户配备观景大阳台为住户提供欣赏全城美景的私密空间。把美景独享亦或分享，皆为美事。挑一个温暖的下午，蜷在慵懒的沙发上看一部期待已久的电影，或和三两好友，品茗小酌各自的精彩。在这里，与自己的理想不期而遇。',
		vhPCTJ3:'ជោគជ័យដ៏អស្ចារ្យ នៅពេលដែលផ្ទះក្លាយទៅជាកម្មសិទ្ធិរបស់អ្នក ធ្វើឱ្យអ្នកមានអារម្មណ៍ស្រណុកសុខស្រួល។',
		vhPCCJ3:'អ្នកមានទម្លាប់រស់នៅក្នុងជីវិតដ៏មមាញឹកឆាប់រហ័ស និងចូលចិត្តប្រណាំងប្រជែងជាមួយពេលវេលា។ ប៉ុន្តែនៅទីនេះអ្នកអាចសោយសុខគ្រប់យ៉ាងដោយសន្សឹមៗ។ ខុនដូ V-House មានទីតាំងស្ថិតនៅជាប់តំបន់ពាណិជ្ជកម្មទួលគោក និងផ្សារទំនើបអ៊ីអ៉នពីរ។ផ្ទះនីមួយៗប្រើប្រាស់ការរចនាប្លង់លក្ខណៈវិទ្យាសាស្រ្តជាមួយនឹងចលនាទាំងមូលដែលលក្ខណៈរលូន និងសមស្រប។ ផ្ទះនីមួយៗមានរានហាលធំទូលាយដែលផ្តល់អ្នកនូវកន្លែងឯកជនដើម្បីរីករាយគយគន់ភាពស្រស់ស្អាតនៃទីក្រុង។ វាជារឿងល្អក្នុងការរីករាយ ឬចែករំលែក។ ឆ្លៀតពេលរសៀល អង្គុយលើសាឡុងមើលភាពយន្ត ឬជជែកកម្សាន្តសប្បាយជាមួយមិត្តភ័ក្តិរបស់អ្នកនិងរីករាយទទួលទានទឹកតែល្អ។',
		
		vhPCT4:'大价值 一屋在手 精彩生活轻松拥有',
		vhPCC4:'25岁买房，30岁而立，偌大的城市，青春有限，自由无价，现在你也能轻松当房东！省下几件名牌华服，让年纪轻轻的当下就提早拥有一间优质的家！V-House精品公寓秉承现代人居理念，小户型，轻总价，买得起，住得好。所在区域潜力巨大，自住或投资出租，即买即享受。依靠，一个叫家的地方。我们的自由天地，完全属于自己！空间独立，休闲放松，更多开心，满足与安全感。在属于自己的一方天地里，生活可以无限精彩！独立自主，轻松置业，是时候了。',
		vhPCTJ4:'គុណតម្លៃដ៏អស្ចារ្យ  ជីវិតដ៏អស្ចារ្យនិងងាយស្រួលក្នុងផ្ទះរបស់អ្នកផ្ទាល់',
		vhPCCJ4:'ទិញផ្ទះនៅអាយុ 25 ឆ្នាំ ហើយកសាងស្នាដៃនៅអាយុ 30។ ជាមួយនឹងទីក្រុងធំ យុវ័យរបស់អ្នកមានដែនកំណត់ មានសេរីភាពហើយមិនអាចកាត់ថ្លៃ ឥឡូវនេះអ្នកអាចក្លាយជាម្ចាស់ផ្ទះបានយ៉ាងងាយស្រួល! សន្សំថវិការបស់អ្នកដើម្បីទិញផ្ទះល្អមួយខ្នងនៅពេលអ្នកនៅក្មេង! ខុនដូ V-House បង្កប់នូវគោលគំនិតថ្មីនៃការរស់នៅ  មានទំហំតូច តម្លៃសមរម្យនិងងាយស្រួលក្នុងការរស់នៅប្រកបដោយផាសុកភាព។ តំបន់នេះមានសក្តានុពលច្រើន ដូច្នេះអ្នកអាចរស់នៅ ឬវិនិយោគដោយដាក់ជួល។ ទិញដើម្បីសោយសុខ។ កន្លែងនេះហៅថាផ្ទះគ្រួសារ។ ពិភពរបស់យើងគឺសេរីភាពរបស់យើង! អ្នកអាចធ្វើជាម្ចាស់ផ្ទះដើម្បីភាពឯកជន ការសម្រាកលំហែ សុភមង្គលសេចក្តីពេញចិត្តនិងសុវត្ថិភាពរបស់អ្នក។ នៅក្នុងពិភពរបស់អ្នក ជីវិតរបស់អ្នកអាចមានភាពអស្ចារ្យ! ដល់ពេលហើយដែលត្រូវមានភាពឯករាជ្យម្ចាស់ការ ដោយទិញអចលនទ្រព្យដ៏អស្ចារ្យនេះ។',
		
	},
*/	
  // 投资者关系
  touzi:{
  	filesize:'文件大小：',
  	hits:'点击次数：',
  	updatetime:'更新时间：',
  	viewDetails:'查看详情',
  	clickDownload:'点击下载',
  	previous:'上一页',
  	next:'下一页',
  	jumpTo:'跳转到'
  },
	// 联系我们
	lianxi:{
		SHAddress:'上海公司',
		SHAddressXQ:'地址：上海市浦东新区世纪大道1500号东方大厦9楼    ',
		SHAddressDH:'    电话：021-6841 9699',
//		SHAddressCZ:'传真：021-68419399',
		SHAddressYB:'邮编：200122',
		XGAddress:'香港地址',
		XGAddressXQ:'地址：香港九龍尖沙咀柯士甸路7至9號煥利商業大廈8樓80室   ',
		XGAddressDH:'    电话：852-28937399',
//		XGAddressCZ:'  传真：852-28937177',
//		JBAddress:'金边地址',
//		JBAddressXQ:'地址：柬埔寨金边市堆谷区150街道214号2楼    '
	},
  footer:{
  	shanghaiAddress:'上海总部地址：上海市浦东新区世纪大道1500号东方大厦9楼    ',
  	shanghaiPhone:'    电话：（021）68419699',
  	HongKongAddress:'香港地址：香港九龍尖沙咀柯士甸路7至9號煥利商業大廈8樓80室    ',
  	HongKongPhone:'    电话：（852）28937399',
//  	jinbianAddress:'金边地址：柬埔寨金边市堆谷区150街道214号2楼    ',
//		jinbianPhone:'    电话：（852）28937866',
  	projectCooperation:'项目合作：my@fortune-sun.com',
	  recruitment:'人才招聘：hr@fortune-sun.com',
	  Complaints:'投诉与建议：complain@fortune-sun.com',
  	investorRelations:'投资者关系：info@fortune-sun.com'
  }
}


//////////////////
// WEBPACK FOOTER
// ./static/lang/zh.js
// module id = z8sE
// module chunks = 16